/**
 * Utility functions for generating unique client identifiers
 */

/**
 * Generate a unique client identifier based on browser characteristics
 * This is used to identify the client across WebSocket connections
 */
export const generateClientId = (): string => {
  let clientName = '';

  if (typeof navigator !== 'undefined') {
    // Use platform as base
    const platform = navigator.platform || 'unknown';

    // Create a more unique identifier using browser characteristics
    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace(/[^a-zA-Z]/g, '');

    // Combine platform with other characteristics for uniqueness
    clientName = `${platform}-${screenResolution}-${timezone}`.toLowerCase();
  } else {
    // Fallback for non-browser environments
    clientName = `client-${Date.now().toString(36)}`;
  }

  // Clean the name to only allow alphanumeric and hyphens
  const cleanName = clientName.replace(/[^a-z0-9-]/g, '').substring(0, 50); // Limit length

  // Add timestamp for additional uniqueness
  const timestamp = Date.now().toString(36);

  return `${cleanName}-${timestamp}`;
};

/**
 * Get a shortened display version of the client ID
 */
export const getShortClientId = (clientId: string): string => {
  // Return last 8 characters for display
  return clientId.slice(-8).toUpperCase();
};
